// Centralised backend base URL + API root.
// Used by every page/component instead of recreating the constants inline.
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
